var e={getLabel:function(e){return"Energy efficiency level ".concat(e)}};export{e as energyIconTranslations};
